<template>
  <AppDialog :is-open="isDialogOpened"
             :cancel-text="$t('project.signing-checklist.dialogs.SigningChecklistPrepareCancelDialog.cancelButtonLabel')"
             :ok-text="$t('project.signing-checklist.dialogs.SigningChecklistPrepareCancelDialog.okButtonLabel')"
             size="l"
             @cancel="closeDialog"
             @ok="confirmClick"
  >
    <template #title>{{ $t('project.signing-checklist.dialogs.SigningChecklistPrepareCancelDialog.dialogTitle') }}</template>

    <template #body>
      <p>{{ $t("project.signing-checklist.dialogs.SigningChecklistPrepareCancelDialog.dialogBody") }}</p>
    </template>
  </AppDialog>
</template>

<script>
import AppDialog from '@/common/dialogs/AppDialog.vue'
import { dialogMixin } from '@/mixins/dialogMixin'

export default {
  name: 'SigningChecklistPrepareCancelDialog',
  components: { AppDialog },
  mixins: [dialogMixin],
  emits: ['confirm'],
  methods: {
    confirmClick () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
}
</script>
